var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPochodzizrecyklingu1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.73 52.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.21.01h-.96c-3.1-.01-6,1.66-7.56,4.36l-4.39,7.61,10.16,5.86L30.26,2.36c.17-.3.36-.58.59-.88.05-.06.1-.12.15-.18l.07-.07c.15-.18.31-.36.48-.52.07-.07.15-.13.22-.2.2-.17.35-.3.5-.41-2.85-.04-6.4-.07-8.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.14,9.34l-4.47-7.3c-.66-1.08-1.78-1.76-3.07-1.86-2.03.02-3.95,1.15-4.98,2.95l-2.54,4.47,4.9,7.72-2.07,1.22,10.52,1.15,3.96-9.68-2.24,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.36,38.27c-.07-.01-.15-.03-.22-.04l-.11-.02c-.23-.04-.46-.09-.68-.16-.09-.03-.19-.06-.28-.09l-.1-.03c-.17-.06-.33-.12-.49-.19,1.88,3.35,4.38,7.79,4.42,7.86,1.55,2.69,4.45,4.36,7.56,4.36h8.79s0-11.73,0-11.73l-17.85.12c-.34,0-.68-.03-1.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.39,33.93c1.04,1.76,2.96,2.85,5.02,2.85l5.18-.03,4.24-8.1,2.14,1.21-4.16-9.8-10.52,1.49,2.28,1.29L.47,30.36c-.6,1.11-.63,2.41-.08,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.56,28.22l-4.39-7.61-10.15,5.87,9,15.36c.17.29.33.61.46.95.03.07.05.15.08.22l.04.11c.08.22.15.44.21.67.03.12.05.24.07.35.04.21.07.39.09.58,1.26-2.12,2.78-4.69,3.72-6.27.53-.89.87-1.47.88-1.49,1.55-2.69,1.55-6.03,0-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.74,48.42c.86-1.52.97-3.44.28-5.1-.1-.24-.22-.47-.35-.69l-2.6-4.44-9.14.39-.02-2.44-6.28,8.4,6.43,8.41-.02-2.57,8.55-.22c1.27-.03,2.41-.66,3.15-1.73Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.46 32.35 29.46 20.59 24.73 20.59 24.73 22.66 27.01 22.66 27.01 32.35 29.46 32.35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPochodzizrecyklingu1Icon);
export default __webpack_public_path__ + "static/media/Pochodzi z recyklingu-1_icon.9828745b3a10c0e631554aa77eea19c4.svg";
export { ForwardRef as ReactComponent };